import { createRoot } from 'react-dom/client'
import { Router } from './router'
import './index.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element #root not found.')

createRoot(rootElement).render(<Router />)
